@use '@/sass/variables';

.container {
  border: 1px solid variables.$moon-gray;
  border-radius: 3px;
  padding: 12px;
  background-color: variables.$near-white;
  width: 90%;
}

.row {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: nowrap;
  gap: 12px;
  margin-bottom: 8px;
  white-space: nowrap;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1 1 0;
  min-width: 0;
}

.label {
  font-size: 0.875rem;
  color: variables.$near-black;
  margin-bottom: 0;
  line-height: 1.2;
}

.numberInput {
  width: 100%;
  margin-bottom: 0;
  padding-left: 6px;
  padding-right: 4px;
}

.everyInput {
  width: 100%;
}

.previewRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 8px;
}

.preview {
  font-size: 1rem;
  color: variables.$black;
  margin: 0;
  flex: 1;
  min-width: 0;
}
